import React, { createContext, useState, useEffect, useCallback } from 'react';
import { login as loginService, logout as logoutService } from '../services/member-auth.service';
import { setOnMemberUnauthorized } from '../services/member-api';

export const MemberAuthContext = createContext({});

export const MemberAuthProvider = ({ children }) => {
  const [member, setMember] = useState(null);
  const [loading, setLoading] = useState(true);

  // Force logout (usado pelo interceptor 401)
  const forceLogout = useCallback(() => {
    localStorage.removeItem('member_token');
    localStorage.removeItem('member_user');
    setMember(null);
  }, []);

  // Carrega associado do localStorage na montagem
  useEffect(() => {
    const loadMember = () => {
      try {
        const token = localStorage.getItem('member_token');
        const memberStr = localStorage.getItem('member_user');

        if (token && memberStr) {
          setMember(JSON.parse(memberStr));
        }
      } catch (error) {
        console.error('Error loading member:', error);
        localStorage.removeItem('member_token');
        localStorage.removeItem('member_user');
      } finally {
        setLoading(false);
      }
    };

    loadMember();
    setOnMemberUnauthorized(forceLogout);

    return () => setOnMemberUnauthorized(null);
  }, [forceLogout]);

  const login = async (email, password) => {
    const response = await loginService(email, password);

    localStorage.setItem('member_token', response.token);
    localStorage.setItem('member_user', JSON.stringify(response.member));

    setMember(response.member);

    return response;
  };

  // Atualiza o associado em memória + localStorage (ex: após upload de foto)
  const updateMember = useCallback((updatedMember) => {
    localStorage.setItem('member_user', JSON.stringify(updatedMember));
    setMember(updatedMember);
  }, []);

  const logout = async () => {
    try {
      await logoutService();
    } catch (error) {
      console.error('Error during member logout:', error);
    } finally {
      forceLogout();
    }
  };

  const isAuthenticated = () => !!member;

  const value = {
    member,
    loading,
    login,
    logout,
    isAuthenticated,
    forceLogout,
    updateMember,
  };

  return <MemberAuthContext.Provider value={value}>{children}</MemberAuthContext.Provider>;
};
